export default __webpack_public_path__ + "media/src/features/footer/assets/instagram-ef004b3399e824b9ac3cfb8203c5e200.png";